import Helpers from "../utils/helpers";

const SinglePost = {
  init() {
    this.events();
  },

  events() {
    $("body").on("click", ".soc-share", function (e) {
      e.preventDefault();

      const btnEl = $(this);

      Helpers.share(btnEl);
    });
  },
};

export default SinglePost;
